import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button, UncontrolledTooltip } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { IScreenStatus } from "../../app/models/screens";
import { RootStoreContext } from "../../app/stores/rootStore";

interface IParams {
  screenStatus: IScreenStatus;
  screensCount: number
}

export const ReorderScreensComponent: React.FC<IParams> = ({ screenStatus, screensCount }) => {
  const rootStore = useContext(RootStoreContext);
  const { moveScreenDown, moveScreenUp } = rootStore.screensStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  return (
    <>
      <Button
        id={`lnkOrderUp_${screenStatus.id}`}
        color="none"
        disabled={screenStatus.order <= 1}
        onClick={() => moveScreenUp(screenStatus.id)}
        className="screenListButton"
      >
        <i className="fas fa-chevron-up fa-2x text-default iconBoxList"></i>
      </Button>
      <UncontrolledTooltip
        delay={0}
        placement="left"
        target={`lnkOrderUp_${screenStatus.id}`}
      >
        {t("screens_modal_table_up")}
      </UncontrolledTooltip>
      <Button
        id={`lnkOrderDown_${screenStatus.id}`}
        color="none"
        disabled={screenStatus.order >= screensCount}
        onClick={() => moveScreenDown(screenStatus.id)}
        className="screenListButton"
      >
        <i className="fas fa-chevron-down fa-2x text-default iconBoxList"></i>
      </Button>
      <UncontrolledTooltip
        delay={0}
        placement="left"
        target={`lnkOrderDown_${screenStatus.id}`}
      >
        {t("screens_modal_table_down")}
      </UncontrolledTooltip>
    </>
  );
};

export default observer(ReorderScreensComponent);
